import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Row, SmallText, Touchable } from 'modules/styled';

HiddenPost.propTypes = {
  onPress: PropTypes.func,
};

function HiddenPost({ onPress }) {
  return (
    <Row>
      <SmallText>This post is hidden because it got too many downvotes. </SmallText>
      <Touchable onPress={onPress}>
        <SmallText sx={{ color: 'blue' }}>Show post.</SmallText>
      </Touchable>
    </Row>
  );
}

export default memo(HiddenPost);
